import CodeMirror from 'codemirror';
import 'codemirror/mode/yaml/yaml.js';
import 'codemirror/mode/javascript/javascript.js';

export default class FormSpecsEditor {
  constructor() {
    const formSpecsContainers = document.querySelectorAll('.form_specs');
    if (formSpecsContainers.length) {
      let idIndex = 0;
      for (const container of formSpecsContainers) {
        const id = 'sd-fse-'+(idIndex++);
        const textarea = container.querySelector('textarea');
        const preview = container.querySelector('#form_specs_preview');
        if ( textarea ) {
          const height = textarea.dataset.height || 300;
          this.initFormSpecs(id, textarea, preview, height )
        }
      }
    }
  }

  initFormSpecs(id, textarea, preview, height) {
    const path = window.location.pathname;
    const pathSplit = path.split('/');
    const orgName = pathSplit[1] === 'o' ? pathSplit[2] : null;
    const isAdminConsole = pathSplit[1] === 'console';
    if ( !orgName && !isAdminConsole ) {
      return;
    }

    if ( preview ) {
      const url = window.location.origin + '/o/'+(orgName || preview.dataset.orgName)+'/form-specs/preview';
      const div = document.createElement('div');
      div.innerHTML = `
      <form id="${id}" target="${id}" action="${url}" method="post">
        <input type="hidden" name="specs" id="${id}_specs">
      </form>
    `;
      document.querySelector('body').appendChild(div);
      preview.innerHTML = `
      <div class="js-error"></div>
      <div class="js-preview"><iframe name="${id}" src="#" style="height: ${height-46}px;"></iframe></div>
    `;

      preview = preview.querySelector('.js-preview');
      preview.classList.add('form-specs-preview');
    }

    this.initCodeMirror(id, textarea, height);
  }

  initCodeMirror(id, textarea, height) {
    const self = this;
    const editor = CodeMirror.fromTextArea(textarea, {
      readOnly: textarea.disabled ? 'nocursor' : false,
      lineNumbers: true,
      mode: textarea.dataset.mode || 'text/x-yaml',
      tabSize: 2,
      indentWithTabs: false,
      extraKeys: {
        Tab: function betterTab(cm) {
          if (cm.somethingSelected()) {
            cm.indentSelection("add");
          } else {
            cm.replaceSelection(cm.getOption("indentWithTabs")? "\t":
              Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");
          }
        }
      },
    });

    self.updatePreview(id, editor);

    if (textarea.disabled) {
      const codeMirrorSizerElement = textarea.nextElementSibling?.querySelector('.CodeMirror-sizer');
      codeMirrorSizerElement.classList.add('bg-sand');
    }

    editor.setSize(null, height);
    editor.on('change', self.updatePreview.bind(this, id, editor));
  }

  updatePreview(id, editor) {
    const previewElem = document.querySelector('#'+id+'_specs');
    if ( !previewElem ) return;

    previewElem.value = editor ? editor.getValue() : '';
    document.querySelector('#'+id).submit();
  }
}
